import { useEffect, useState } from 'react'
import Scroll from 'react-scroll'
import { useUpdateEffect } from 'react-use'

import { Header, PageLoading, Steps } from '@Components'
import { Feedback } from '@corabank/arco'
import { getRegistrationStatus } from '@Requests'
import { useSteps, useDocs } from '@Store'

import { UploadDocsStep, SuccessStep } from '../../containers'
import { HOME_TEXTS } from './constants'
import * as Styled from './styles'

const Home = (): JSX.Element => {
  const { step, goStep, skipStep } = useSteps()
  const {
    businessStatus,
    error,
    filterRegistrationDocs,
    registerId,
    setBusinessName,
    setBusinessStatus,
    setError,
    setSuccess,
    success,
  } = useDocs()
  const [isLoading, setIsLoading] = useState(true)

  const handleFetchRegistrationStatus = async (): Promise<void> => {
    try {
      setIsLoading(true)

      if (registerId) {
        const { data } = await getRegistrationStatus(registerId)
        setBusinessName(data?.tradeName || '')
        setBusinessStatus(data?.status)
        filterRegistrationDocs(data?.currentStages || [])
      }
    } catch {
      setError(HOME_TEXTS.ERROR_MESSAGE)
      setBusinessName('')
      setBusinessStatus('')
      filterRegistrationDocs([])
    } finally {
      setIsLoading(false)
    }
  }

  const scrollToTop = () => {
    const scroll = Scroll.animateScroll
    scroll.scrollToTop({
      duration: 100,
      smooth: 'easeInOutQuint',
    })
  }

  const handleCloseFeedback = () => {
    setError('')
    setSuccess('')
  }

  const goToInitialStep = () => {
    if (step > 1 && !skipStep && !success) goStep(1)
  }

  const renderFeedback = () => {
    const type = success ? 'info' : 'danger'
    const message = success || error

    if (!message) return

    return (
      <Feedback
        open={Boolean(message)}
        onClose={handleCloseFeedback}
        type={type}
      >
        {message}
      </Feedback>
    )
  }

  useEffect(() => {
    goToInitialStep()
    handleFetchRegistrationStatus()
  }, [])

  useEffect(() => {
    scrollToTop()
  }, [step])

  useUpdateEffect(() => {
    ;(error || success) && scrollToTop()
  }, [error, success])

  useEffect(() => {
    if (['IN_ANALYSIS', 'FINALIZED'].includes(businessStatus)) goStep(2)
  }, [businessStatus])

  return isLoading ? (
    <PageLoading />
  ) : (
    <>
      <Header />

      <Styled.Home>
        {renderFeedback()}

        <Styled.Content>
          <Steps>
            <UploadDocsStep />
            <SuccessStep />
          </Steps>
        </Styled.Content>
      </Styled.Home>
    </>
  )
}

export default Home
